import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@quebon/ui/components/select'

import type { AdminLcCenterStatus } from '@/api/admin'

export const LC_CENTER_STATUS_LABEL: Record<AdminLcCenterStatus, string> = {
  EDUCATION: '교육',
  OPERATING: '운영',
  ON_HOLD: '보류',
  TERMINATED: '해지',
}

interface LcCenterStatusSelectProps {
  value: AdminLcCenterStatus
  onValueChange: (value: AdminLcCenterStatus) => void
}

export function LcCenterStatusSelect({ value, onValueChange }: LcCenterStatusSelectProps) {
  return (
    <Select
      items={LC_CENTER_STATUS_LABEL}
      value={value}
      onValueChange={(next) => {
        if (next) onValueChange(next as AdminLcCenterStatus)
      }}
    >
      <SelectTrigger id="lc-center-operational-status" className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="EDUCATION">교육</SelectItem>
          <SelectItem value="OPERATING">운영</SelectItem>
          <SelectItem value="ON_HOLD">보류</SelectItem>
          <SelectItem value="TERMINATED">해지</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
